
import Vue from 'vue'
import {State} from 'vuex-class'
import Component from 'vue-class-component'
import GroupService from '@/services/GroupService'
import CardTitle from '@/components/Atomic/CardTitle.vue'
import {User as Storeuser} from '../../store/index'
import ErrorHandlerService from '@/services/ErrorHandlerService'
import { Assignment } from '@/models/assignments'
import AutocompleteMultipleWTooltip from '../Atomic/AutocompleteMultipleWTooltip.vue'
import AssignmentService from '@/services/AssignmentService'
import GreenButton from '../Atomic/GreenButton.vue'
import RedButton from '../Atomic/RedButton.vue'
import { Group, GroupBasic } from '@/models/group'
import { read } from 'xlsx'
import { Prop } from 'vue-property-decorator'

@Component({
  components: {
    AutocompleteMultipleWTooltip,
    CardTitle,
    GreenButton,
    RedButton,
  },
})
export default class AssignmentDetails extends Vue {
  @Prop(Function) public readonly onClose!: () => void
  @State private user!: Storeuser
  private isReadOnly: boolean = false
  private assignment: Assignment = {} as Assignment
  private dialog: boolean = false
  private errorHandlerService: ErrorHandlerService
  private isPending: boolean = false
  private groups: GroupBasic[] = []

  constructor() {
    super()
    this.errorHandlerService = new ErrorHandlerService()
  }

  public async show(assignment: Assignment, readonly: boolean) {
    this.isReadOnly = readonly
    this.assignment = assignment
    this.dialog = true
    this.isPending = true
    await this.fetchAssignmentGroups(this.assignment)
    await this.fetchGroups()
    this.isPending = false
  }

  private closeDialog() {
    this.dialog = false
    if (this.isReadOnly === false) {
      this.onClose()
    }
  }

  private async fetchAssignmentGroups(assignment: Assignment) {
    try {
        const groups = await AssignmentService.fetchAssignmentGroups(assignment)
        assignment.groups = groups
    } catch (error: any) {
        this.errorHandlerService.handle(this, error.response.data.code, true)
    }
  }

  private async fetchGroups() {
    try {
      this.groups = await GroupService.get(true)
    } catch (error: any) {
        this.errorHandlerService.handle(this, error.response.data.code, true)
    }
  }

  private async validate() {
    try {
      this.isPending = true
      await AssignmentService.update(this.assignment, this.assignment.id)
      this.closeDialog()
    } catch (error: any) {
      this.errorHandlerService.handle(this, error.response.data.code, true)
    } finally {
      this.isPending = false
    }
  }
}
